export default __webpack_public_path__ + "static/media/csk.09fa6cf9.png";